module.exports = __webpack_public_path__ + "static/media/Invest_next.6c7006d1.png";